import React from 'react';
import { motion } from 'framer-motion';
import { CalendarIcon, GaugeIcon, ZapIcon, ImageIcon } from 'lucide-react';
import { useLanguage } from '../lib/i18n';
interface VehicleCardProps {
  image: string;
  name: string;
  year: string;
  mileage: string;
  power: string;
  price: string;
  hasPhotos?: boolean;
  onClick?: () => void;
}
export function VehicleCard({
  image,
  name,
  year,
  mileage,
  power,
  price,
  hasPhotos = true,
  onClick
}: VehicleCardProps) {
  const {
    t
  } = useLanguage();
  return <motion.div initial={{
    opacity: 0,
    y: 30
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-50px'
  }} transition={{
    duration: 0.6
  }} className="group relative bg-[#1c1c1c] border border-[#2a2a2a] rounded-xl overflow-hidden hover:border-[#c8a96e]/30 transition-all duration-500 cursor-pointer" onClick={onClick} data-id="element-149">
      {/* Image or Placeholder */}
      <div className="aspect-[4/3] overflow-hidden" data-id="element-150">
        {hasPhotos && image ? <img src={image} alt={name} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-151" /> : <div className="w-full h-full bg-[#141414] flex flex-col items-center justify-center" data-id="element-152">
            <ImageIcon className="w-16 h-16 text-[#2a2a2a] mb-4" data-id="element-153" />
            <p className="text-[#737373] text-sm" data-id="element-154">
              {t('vehicleDetail.photosComingSoon')}
            </p>
          </div>}
      </div>

      {/* Content */}
      <div className="p-6" data-id="element-155">
        <h3 className="text-xl font-semibold text-white mb-4 group-hover:text-[#c8a96e] transition-colors min-h-[3.5rem]" data-id="element-156">
          {name}
        </h3>

        {/* Specs */}
        <div className="grid grid-cols-3 gap-4 mb-6" data-id="element-157">
          <div className="flex items-center gap-2 text-[#a3a3a3]" data-id="element-158">
            <CalendarIcon className="w-4 h-4 text-[#737373]" data-id="element-159" />
            <span className="text-sm" data-id="element-160">{year}</span>
          </div>
          <div className="flex items-center gap-2 text-[#a3a3a3]" data-id="element-161">
            <GaugeIcon className="w-4 h-4 text-[#737373]" data-id="element-162" />
            <span className="text-sm" data-id="element-163">{mileage}</span>
          </div>
          <div className="flex items-center gap-2 text-[#a3a3a3]" data-id="element-164">
            <ZapIcon className="w-4 h-4 text-[#737373]" data-id="element-165" />
            <span className="text-sm" data-id="element-166">{power}</span>
          </div>
        </div>

        {/* Price & CTA */}
        <div className="flex items-center justify-between pt-4 border-t border-[#2a2a2a]" data-id="element-167">
          <span className="text-[#c8a96e] font-semibold" data-id="element-168">{price}</span>
          <span className="text-sm text-white group-hover:text-[#c8a96e] font-medium transition-colors" data-id="element-169">
            {t('vehicles.viewDetail')} →
          </span>
        </div>
      </div>
    </motion.div>;
}